export default "__VITE_ASSET__1333f009__"